import { Component, inject } from '@angular/core';
import { RouterRepository } from '@ngneat/elf-ng-router-store';
import { map } from 'rxjs';

@Component({
  selector: 'digital-platform-header-shell',
  templateUrl: './shell.component.html',
})
export class ShellComponent {
  private routerRepository = inject(RouterRepository);

  public hideHeader$ = this.routerRepository
    .select((state) => state.state?.url)
    .pipe(map((url) => url && url.startsWith('/municipality')));
}
